import React, { useEffect, useState, useRef } from "react";
import "./CourseManagement.css";
import { Form, FloatingLabel, Modal, Button, Alert } from "react-bootstrap";
import CourseService from "../../../services/course.service";
import AuthService from "../../../services/auth.service";
import PathwayService from "../../../services/pathway.service";
import CoursecatService from "../../../services/coursecat.service";
import { useNavigate } from "react-router-dom";
import "./publishCourse.css";

import CourseImg from "../../../assets/images/course-placeholder.png";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OverviewPublish = ({ prevStep, cid }) => {
  const navigate = useNavigate();

  const [uploaded, setUploaded] = useState(false);
  const [dataUpload, setDataUpload] = useState(false);
  const [message, setMessage] = useState("");
  const [estorechecked, setEstorechecked] = useState(false);
  const [whitelistchecked, setWhitelistchecked] = useState(false);
  const [isPrice, setIsPrice] = useState(false);
  const [isValidity, setIsValidity] = useState(false);

  const [courseDetails, setCourseDetails] = useState({
    user_id: "",
    courseimg: "",
    name: "",
    catid: "",
    description: "",
    courseid: cid,
  });

  const [courseActivities, setCourseActivities] = useState([]);
  const [prereq, setPrereq] = useState({
    sts: "", // status
    pathid: "", // pathway id
    precid: "", // course in pathway
    occup: "", // occupation
    comcid: "", // completing course
    pathcourses: "", // pathway courses count
  });

  const [publish, setPublish] = useState({
    course_id: cid,
    wht: "",
    estore: "",
    price: "",
    validity: "",
  });

  useEffect(() => {
    const user = AuthService.getCurrentUser();

    setCourseDetails({ ...courseDetails, user_id: user.user });

    CourseService.getCourseById(user.user, cid)
      .then((response) => {
        CoursecatService.getCourseCat(user.user)
          .then((res) => {
            const filteredData = res.data.filter(
              (coursecat) =>
                coursecat.id == response.data.course_info[0].category_id
            );

            setCourseDetails({
              courseimg: response.data.course_info[0].course_image,
              name: response.data.course_info[0].name,
              catid: filteredData[0].course_catename,
              description: response.data.course_info[0].description,
              courseid: cid,
            });
          })
          .catch((e) => {
            console.log(e);
          });
      })
      .catch((e) => {
        console.log(e);
      });

    CourseService.getCourseActivity(cid)
      .then((response) => {
        setCourseActivities(response.data);
      })
      .catch((e) => console.log(e));

    CourseService.getPrerequisites(cid, user.user)
      .then((response) => {
        PathwayService.getPathwayById(response.data[0].pathway_id)
          .then((res) => {
            CourseService.getCourseById(
              user.user,
              response.data.course_info[0].comcid
            )
              .then((courseRes) => {
                setPrereq({
                  sts: response.data.course_info[0].pathsts, // status
                  pathid: res.data[0].name, // pathway id
                  precid: response.data.course_info[0].precid, // course in pathway
                  occup: response.data.course_info[0].occup, // occupation
                  comcid: courseRes.data[0].name, // completing course
                  pathcourses: res.data.length,
                });
              })
              .catch((e) => console.log(e));
          })
          .catch((e) => console.log(e));
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const prevPage = (e) => {
    e.preventDefault();
    prevStep();
  };

  const [validated, setValidated] = useState(false);

  const handleEstoreChecked = (e) => {
    setEstorechecked(!estorechecked);
    if (estorechecked === false) {
      setPublish({ ...publish, estore: 1 });
    } else {
      setPublish({ ...publish, estore: 0 });
    }
  };

  const handleWhitelistChecked = (e) => {
    setWhitelistchecked(!whitelistchecked);
    if (whitelistchecked === false) {
      setPublish({ ...publish, wht: 1 });
    } else {
      setPublish({ ...publish, wht: 0 });
    }
  };

  const handleEstorePrice = (e) => {
    setIsPrice(true);
    setPublish({ ...publish, price: e.target.value });
  };

  const handleEstoreValidity = (e) => {
    setIsValidity(true);
    setPublish({ ...publish, validity: e.target.value });
  };

  const handleSubmit = async (event) => {
    // const form = event.currentTarget;
    // if (form.checkValidity() === false) {
    //   event.preventDefault();
    //   event.stopPropagation();
    // }

    // setValidated(true);
    // event.preventDefault();

    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const user = AuthService.getCurrentUser();

    const data = {
      course_id: publish.course_id,
      wht: publish.wht,
      estore: publish.estore,
      prize: publish.price,
      expdate: publish.validity,
      usp: user.user,
    };

    if (courseActivities.length > 0) {
      if (estorechecked) {
        if (isPrice && isValidity) {
          CourseService.publishCourse(data)
            .then((res) => {
              // setDataUpload(true);
              setMessage("Course published successfully in E-store!");

              toast.success("Course published successfully in E-store!", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });

              setTimeout(() => {
                // setDataUpload(false);
                navigate("/ManageCourses");
              }, 2000);
            })
            .catch((e) => console.log(e));
        } else {
          toast.warn("Price and Validity for E-store is required!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      } else {
        CourseService.publishCourse(data)
          .then((res) => {
            // setDataUpload(true);
            setMessage("Course published successfully!");

            toast.success("Course published successfully!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });

            setTimeout(() => {
              // setDataUpload(false);
              navigate("/ManageCourses");
            }, 2000);
          })
          .catch((e) => console.log(e));
      }
    } else {
      toast.warn(
        "You have not added any activities yet. Please add atleast one activity to publish the course.!",
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    }
  };
  return (
    <>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <ToastContainer />
        <div className="preview-course">
          <div className="row">
            <div className="col-xl-5 col-lg-5">
              <div className="course-order">
                <div className="topics-list">
                  <div className="topics">
                    <div className="topic-info">
                      <div className="topic-content">
                        <span className="name">Course Order</span>
                      </div>
                    </div>
                    <div className="conditions">
                      <div className="topic-content">
                        <span className="name">Conditions</span>
                      </div>
                    </div>
                  </div>
                  {Array.isArray(courseActivities)
                    ? courseActivities.map((courseActivity) => {
                        return (
                          <div className="topics" key={courseActivity.id}>
                            <div className="topic-info">
                              <div className="icon">
                                <span>
                                  {courseActivity.file_name.includes(".mp4") ? (
                                    <>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30.889"
                                        height="26.391"
                                        viewBox="0 0 30.889 26.391"
                                      >
                                        <g
                                          id="youtube"
                                          transform="translate(0 0)"
                                        >
                                          <path
                                            id="Subtraction_8"
                                            data-name="Subtraction 8"
                                            d="M12.382,26.391c-8.785,0-8.811-.012-9.463-.335L2.813,26A5.1,5.1,0,0,1,.344,23.243l-.027-.072C0,22.334,0,22.334,0,14.087v-1.8C0,4.065,0,4.065.313,3.217l.025-.069A4.794,4.794,0,0,1,3.591.109C3.956.022,5.5.008,15.408,0h3.736c6.766,0,7.76.02,8.122.1A4.86,4.86,0,0,1,30.809,4.1c.084.475.09,1.348.072,9.334l0,1.592c-.013,7.485-.013,7.485-.3,8.181-.019.046-.04.1-.062.15a5.148,5.148,0,0,1-2.487,2.694l-.09.04c-.662.294-.688.306-10.079.306H12.382ZM12.738,7.11a.88.88,0,0,0-.789.532c-.12.257-.12.356-.12,5.55s0,5.293.12,5.55a.883.883,0,0,0,.792.532.741.741,0,0,0,.373-.1c.1-.055,1.541-1.056,3.862-2.68,3.322-2.33,3.676-2.594,3.784-2.83a1.052,1.052,0,0,0,0-.947c-.108-.235-.462-.5-3.784-2.83-2.321-1.624-3.765-2.626-3.862-2.68A.754.754,0,0,0,12.738,7.11Z"
                                            transform="translate(0 0)"
                                            fill="#ffffff"
                                          />
                                        </g>
                                      </svg>
                                    </>
                                  ) : courseActivity.file_name.includes(
                                      ".pdf"
                                    ) ? (
                                    <>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22.365"
                                        height="26.83"
                                        viewBox="0 0 22.365 26.83"
                                      >
                                        <g
                                          id="pdf-file"
                                          transform="translate(0)"
                                        >
                                          <path
                                            id="Path_13703"
                                            data-name="Path 13703"
                                            d="M86.962-468.88a3.083,3.083,0,0,0-.621.271,3.448,3.448,0,0,0-1.014,1.058c-.333.63-.327.3-.327,11.969s-.007,11.339.327,11.975a3.613,3.613,0,0,0,1.072,1.09c.66.372.163.359,9.92.34l8.92-.019.379-.145a3.28,3.28,0,0,0,1.373-1.2c.379-.668.373-.447.373-9.3v-8.126l-4.166-4.013L99.027-469l-5.853.006C87.766-468.994,87.3-468.987,86.962-468.88Zm14.158,5.928,3.466,3.339h-7.03v-3.339c0-1.839.02-3.339.052-3.339S99.217-464.792,101.12-462.953Zm-9.234,10.173a1.51,1.51,0,0,1,1.288,1.55,1.457,1.457,0,0,1-.49,1.235,2.308,2.308,0,0,1-1.74.586h-.517v1.89H89.185l.013-2.633.02-2.627.262-.038A10.785,10.785,0,0,1,91.886-452.779Zm5,0a2.433,2.433,0,0,1,1.694,1.147,2.984,2.984,0,0,1-.163,3.03c-.536.794-1.5,1.14-3.126,1.146-.471,0-.955-.019-1.066-.038l-.2-.044V-452.8l.281-.025A13.914,13.914,0,0,1,96.889-452.779Zm6.278.422.02.491h-2.165v1.26h2.027v.945h-2.027v2.142H99.779v-5.354l1.687.013,1.681.019Z"
                                            transform="translate(-85 469)"
                                            fill="#ffffff"
                                          />
                                          <path
                                            id="Path_13704"
                                            data-name="Path 13704"
                                            d="M168.118-198.921c-.1.025-.118.12-.118.8v.775l.19.038a1.743,1.743,0,0,0,.87-.12.79.79,0,0,0,.275-1.216A1.322,1.322,0,0,0,168.118-198.921Z"
                                            transform="translate(-162.572 215.973)"
                                            fill="#ffffff"
                                          />
                                          <path
                                            id="Path_13705"
                                            data-name="Path 13705"
                                            d="M242.249-198.518l-.248.025v3.534l.575-.025a1.576,1.576,0,0,0,1.674-1.209,3.938,3.938,0,0,0-.026-1.335A1.766,1.766,0,0,0,242.249-198.518Z"
                                            transform="translate(-231.733 215.571)"
                                            fill="#ffffff"
                                          />
                                        </g>
                                      </svg>
                                    </>
                                  ) : courseActivity.file_name.includes(
                                      ".doc"
                                    ) ? (
                                    <>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22.365"
                                        height="26.83"
                                        viewBox="0 0 22.365 26.83"
                                      >
                                        <g
                                          id="pdf-file"
                                          transform="translate(0)"
                                        >
                                          <path
                                            id="Path_13703"
                                            data-name="Path 13703"
                                            d="M86.962-468.88a3.083,3.083,0,0,0-.621.271,3.448,3.448,0,0,0-1.014,1.058c-.333.63-.327.3-.327,11.969s-.007,11.339.327,11.975a3.613,3.613,0,0,0,1.072,1.09c.66.372.163.359,9.92.34l8.92-.019.379-.145a3.28,3.28,0,0,0,1.373-1.2c.379-.668.373-.447.373-9.3v-8.126l-4.166-4.013L99.027-469l-5.853.006C87.766-468.994,87.3-468.987,86.962-468.88Zm14.158,5.928,3.466,3.339h-7.03v-3.339c0-1.839.02-3.339.052-3.339S99.217-464.792,101.12-462.953Zm-9.234,10.173a1.51,1.51,0,0,1,1.288,1.55,1.457,1.457,0,0,1-.49,1.235,2.308,2.308,0,0,1-1.74.586h-.517v1.89H89.185l.013-2.633.02-2.627.262-.038A10.785,10.785,0,0,1,91.886-452.779Zm5,0a2.433,2.433,0,0,1,1.694,1.147,2.984,2.984,0,0,1-.163,3.03c-.536.794-1.5,1.14-3.126,1.146-.471,0-.955-.019-1.066-.038l-.2-.044V-452.8l.281-.025A13.914,13.914,0,0,1,96.889-452.779Zm6.278.422.02.491h-2.165v1.26h2.027v.945h-2.027v2.142H99.779v-5.354l1.687.013,1.681.019Z"
                                            transform="translate(-85 469)"
                                            fill="#ffffff"
                                          />
                                          <path
                                            id="Path_13704"
                                            data-name="Path 13704"
                                            d="M168.118-198.921c-.1.025-.118.12-.118.8v.775l.19.038a1.743,1.743,0,0,0,.87-.12.79.79,0,0,0,.275-1.216A1.322,1.322,0,0,0,168.118-198.921Z"
                                            transform="translate(-162.572 215.973)"
                                            fill="#ffffff"
                                          />
                                          <path
                                            id="Path_13705"
                                            data-name="Path 13705"
                                            d="M242.249-198.518l-.248.025v3.534l.575-.025a1.576,1.576,0,0,0,1.674-1.209,3.938,3.938,0,0,0-.026-1.335A1.766,1.766,0,0,0,242.249-198.518Z"
                                            transform="translate(-231.733 215.571)"
                                            fill="#ffffff"
                                          />
                                        </g>
                                      </svg>
                                    </>
                                  ) : (
                                    <>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="35"
                                        height="30"
                                        viewBox="0 0 54.269 43.126"
                                      >
                                        <g
                                          id="Group_11456"
                                          data-name="Group 11456"
                                          transform="translate(-372.554 -403.874)"
                                        >
                                          <path
                                            id="Subtraction_10"
                                            data-name="Subtraction 10"
                                            d="M3329.57,5900c-3.291,0-6.615,0-9.881-.006h-19.938a6.905,6.905,0,0,1-7.112-5.823,7.178,7.178,0,0,1-.084-1.235v-28.985a7.092,7.092,0,0,1,1.6-4.618,6.95,6.95,0,0,1,4.215-2.367,8.287,8.287,0,0,1,1.227-.093l.2,0h10.854a6.908,6.908,0,0,1,6.637,4.238c.969,2.016,1.727,3.671,2.387,5.208a3.48,3.48,0,0,0,3.544,2.279h.022c2.953-.007,6.029-.011,9.974-.011h11.325c1.648,0,2.291.64,2.291,2.283v21.944a6.879,6.879,0,0,1-5.261,6.967,9.087,9.087,0,0,1-1.934.208h-.174C3336.186,5900,3332.861,5900,3329.57,5900Zm-19.243-15.02a3.965,3.965,0,0,0-2.865,1.143,4.065,4.065,0,0,0-.022,5.688,4.149,4.149,0,0,0,6.012-.353l-1.1-1.133a2.54,2.54,0,0,1-2.067,1,2.154,2.154,0,0,1-1.574-.648,2.34,2.34,0,0,1-.648-1.722,2.215,2.215,0,0,1,.687-1.7,2.372,2.372,0,0,1,1.656-.632,2.511,2.511,0,0,1,2.024,1.011l1.067-1.209A4.079,4.079,0,0,0,3310.327,5884.98Zm-10.119,5.345h0l-1.023,1.254a4.739,4.739,0,0,0,3.289,1.353,3.1,3.1,0,0,0,2.04-.644,2.081,2.081,0,0,0,.776-1.677,2,2,0,0,0-.605-1.573,3.935,3.935,0,0,0-1.7-.809,5.54,5.54,0,0,1-1.4-.468.611.611,0,0,1-.3-.533.657.657,0,0,1,.247-.539,1.036,1.036,0,0,1,.677-.2,3.394,3.394,0,0,1,2.067.758l.869-1.254a4.121,4.121,0,0,0-1.342-.748,4.747,4.747,0,0,0-1.54-.264,3.18,3.18,0,0,0-1.964.594,2,2,0,0,0-.786,1.688,1.968,1.968,0,0,0,.62,1.606,4.966,4.966,0,0,0,1.963.831,3.787,3.787,0,0,1,1.134.412.684.684,0,0,1,.016,1.1,1.216,1.216,0,0,1-.743.2A3.647,3.647,0,0,1,3300.208,5890.326Zm17.918-5.345a3.966,3.966,0,0,0-2.871,1.139,4.025,4.025,0,0,0,0,5.665,4.189,4.189,0,0,0,5.742,0,4.022,4.022,0,0,0,0-5.665A3.966,3.966,0,0,0,3318.126,5884.98Zm20.371,3.029h0v4.834h1.716v-7.687H3337.9l-1.99,4.225-1.98-4.225h-2.322v7.688h1.716v-4.839l2.069,4.2h1.023Zm-14.882-2.853v7.688h1.716v-2.451h1.189l1.7,2.452h2.111l-1.947-2.75a2.271,2.271,0,0,0,1.463-2.387,2.348,2.348,0,0,0-.764-1.947,4.2,4.2,0,0,0-2.557-.6Zm-22.551-17.237v8.764a.225.225,0,0,0,.173.255c2.016.752,4.126,1.542,6.274,2.348l1.017.379V5870.9a.223.223,0,0,0-.173-.253l-5.93-2.221-.329-.123Zm15.91,0-.42.158c-.784.295-1.618.608-2.426.907l-2.129.807-.173.061-.462.173c-.539.2-1.116.419-1.689.629a.2.2,0,0,0-.157.231v8.782l7.457-2.8v-8.951Zm-7.948-3.955a.357.357,0,0,0-.116.02c-2.678,1-5.362,2.007-7.667,2.873a.857.857,0,0,0-.09.037l-.005,0-.063.028.044.019.011.005.005,0a.707.707,0,0,0,.066.026c2.31.868,4.76,1.786,7.71,2.889a.293.293,0,0,0,.1.017.286.286,0,0,0,.1-.017c.822-.3,1.656-.617,2.464-.921l.069-.026.183-.069a.747.747,0,0,0,.083-.039l.011-.005.043-.022,2.137-.788c.565-.216,1.142-.432,1.7-.642l.092-.034.428-.161.362-.136.27-.1-.073-.031-.007,0c-.048-.021-.085-.037-.123-.05-2.834-1.065-5.328-2-7.623-2.855A.355.355,0,0,0,3309.026,5863.964Zm9.106,27.462a2.12,2.12,0,0,1-1.623-.721,2.658,2.658,0,0,1,0-3.5,2.178,2.178,0,0,1,3.246,0,2.658,2.658,0,0,1,0,3.5A2.12,2.12,0,0,1,3318.132,5891.426Zm8.453-2.519h-1.254v-2.277h1.287a2.119,2.119,0,0,1,1.155.231.977.977,0,0,1,.33.853,1.166,1.166,0,0,1-.318.908A1.858,1.858,0,0,1,3326.585,5888.907Z"
                                            transform="translate(-2920 -5453)"
                                            fill="#fff"
                                          />
                                          <path
                                            id="Path_13693"
                                            data-name="Path 13693"
                                            d="M1068.11,261.36h19.926a6.9,6.9,0,0,1,6.885,5.228c.054.2.079.416.133.7a13.384,13.384,0,0,0-4.558-.33q-9.464-.03-18.929,0a1.235,1.235,0,0,1-1.329-.876c-.567-1.362-1.214-2.687-1.827-4.033C1068.314,261.852,1068.229,261.638,1068.11,261.36Z"
                                            transform="translate(-668.322 146.086)"
                                            fill="#fff"
                                          />
                                        </g>
                                      </svg>
                                    </>
                                  )}
                                </span>
                              </div>
                              <div className="topic-content">
                                <span className="name">
                                  {courseActivity.activity_name}
                                </span>
                                {courseActivity.file_name.includes(".mp4") ? (
                                  <>
                                    <span className="type">Video</span>
                                  </>
                                ) : courseActivity.file_name.includes(
                                    ".pdf"
                                  ) ? (
                                  <>
                                    <span className="type">PDF</span>
                                  </>
                                ) : courseActivity.file_name.includes(
                                    ".doc"
                                  ) ? (
                                  <>
                                    <span className="type">Doc</span>
                                  </>
                                ) : (
                                  <>
                                    <span className="type">SCORM</span>
                                  </>
                                )}
                              </div>
                            </div>
                            <div className="conditions">
                              <span>
                                {courseActivity.restrictAccess === "1"
                                  ? "None"
                                  : "After Previous"}
                              </span>
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
            <div className="col-xl-7 col-xl-7">
              <div className="course-info">
                <div className="header">
                  <span>Course Details</span>
                </div>
                <div className="course-info-flex">
                  <div className="course-img">
                    {courseDetails.courseimg !== "" ? (
                      <>
                        <img
                          src={
                            "https://elearning.gaa.aero/cit/" +
                            courseDetails.courseimg
                          }
                          className="img-fluid"
                          alt=""
                        />
                      </>
                    ) : (
                      <>
                        <img src={CourseImg} className="img-fluid" alt="" />
                      </>
                    )}
                  </div>
                  <div className="course-details">
                    <div className="top">
                      <div className="course-name">
                        <span>{courseDetails.name}</span>
                      </div>
                    </div>
                    <div className="bottom">
                      <div className="course-cat">
                        <span>
                          Category:{" "}
                          <span className="val">{courseDetails.catid}</span>
                        </span>
                      </div>
                      {prereq.sts === "1" ? (
                        <>
                          <div className="course-pathways">
                            <span>Pathway: {prereq.pathid}</span>
                          </div>
                          <div className="course-pathways-count">
                            <span>
                              Total Courses in Pathway : {prereq.pathcourses}
                            </span>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      <div className="course-cat">
                        <span>Occupation Category: {prereq.occup}</span>
                      </div>
                      <div className="course-cat">
                        <span>
                          {/* Visible after completing this course {prereq.comcid} */}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="course-action">
                  <div className="checkbox">
                    <input
                      className="styled-checkbox"
                      id="styled-checkbox-1"
                      type="checkbox"
                      value="value1"
                      onChange={handleEstoreChecked}
                      checked={estorechecked}
                    />
                    <label htmlFor="styled-checkbox-1">E-Store Enable</label>
                  </div>
                  <div className="checkbox">
                    <input
                      className="styled-checkbox"
                      id="styled-checkbox-2"
                      type="checkbox"
                      value="value1"
                      onChange={handleWhitelistChecked}
                      checked={whitelistchecked}
                    />
                    <label htmlFor="styled-checkbox-2">Whitelist Enable</label>
                  </div>
                </div>
                {estorechecked ? (
                  <div className="estore-price-details">
                    <div className="estore-price">
                      <label>Price*</label>
                      <input
                        type="text"
                        placeholder="Enter price"
                        onChange={handleEstorePrice}
                      />
                    </div>
                    <div className="estore-price">
                      <label>Validity*</label>
                      <div className="input-box">
                        <input
                          className="estore-date"
                          type="date"
                          onChange={handleEstoreValidity}
                        />
                        <span className="estore-date-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="14.02"
                            viewBox="0 0 81.923 76.58"
                          >
                            <g id="calendar" transform="translate(-15 482)">
                              <path
                                id="Path_13206"
                                data-name="Path 13206"
                                d="M20.071-481.763a6.872,6.872,0,0,0-4.139,3.494c-.8,1.577-.933,2.68-.933,8.175v5.054H96.77l-.051-5.394-.051-5.377-.543-1.153a9.468,9.468,0,0,0-6.31-4.8A33.656,33.656,0,0,0,84.592-482H80.47v3.85a39.256,39.256,0,0,1-.17,4.461,3,3,0,0,1-.763,1.187,1.965,1.965,0,0,1-1.476.645,1.8,1.8,0,0,1-1.476-.339c-1.289-.882-1.289-.865-1.34-5.58L75.179-482H34.505v3.681c-.017,4.427-.1,4.987-.9,5.767a2.54,2.54,0,0,1-3.9-.441c-.356-.577-.373-.814-.424-4.817L29.23-482l-4.189.017A31.215,31.215,0,0,0,20.071-481.763Z"
                              />
                              <path
                                id="Path_13207"
                                data-name="Path 13207"
                                d="M15.034-326.627l.051,24.39.441,1.119a6.553,6.553,0,0,0,4.122,4.172c.814.288,2.612.305,35.551.305H89.884l1.136-.39a9.341,9.341,0,0,0,5.275-4.444l.543-1.1.051-24.2L96.923-351H15ZM38.9-341.281a2.562,2.562,0,0,1,.763.678c.322.441.356.746.407,3.935.051,3.155.034,3.528-.271,4.223-.594,1.34-.746,1.374-5.054,1.374-5.343,0-5.156.2-5.156-5.224,0-5.411-.22-5.19,5.173-5.19A16.623,16.623,0,0,1,38.9-341.281Zm20.184,0a2.562,2.562,0,0,1,.763.678c.322.441.356.746.407,3.986.068,3.9-.051,4.58-.865,5.19-.458.339-.7.356-4.359.356-5.462,0-5.258.22-5.258-5.224,0-5.411-.22-5.19,5.173-5.19A16.623,16.623,0,0,1,59.082-341.281Zm20.54.034c.933.492,1.018.882,1.018,5,0,5.445.271,5.173-5.241,5.173-3.731,0-3.85-.017-4.376-.39-.78-.56-.9-1.187-.9-4.919,0-3.562.1-4.1.933-4.749.458-.356.628-.373,4.274-.373C78.4-341.5,79.232-341.451,79.622-341.247ZM39.2-318.129c.78.56.9,1.187.9,4.834,0,3.46-.1,3.935-.916,4.7-.458.424-.475.424-4.274.475-3.613.051-3.85.034-4.376-.305-.916-.56-.967-.882-.916-5.139.051-3.782.051-3.833.458-4.257a2.607,2.607,0,0,1,.933-.611,33.768,33.768,0,0,1,4.088-.119C38.508-318.519,38.678-318.5,39.2-318.129Zm20.082-.085c.848.577.916.9.916,4.851a36.048,36.048,0,0,1-.136,4.139,1.659,1.659,0,0,1-.678.8c-.492.305-.865.339-4.325.339-5.563,0-5.326.237-5.258-5.428.051-3.85.051-3.884.458-4.308a2.607,2.607,0,0,1,.933-.611,33.768,33.768,0,0,1,4.088-.119C58.37-318.519,58.9-318.485,59.286-318.214Zm19.845-.221a2.965,2.965,0,0,1,1.018.611l.407.441v8.277l-.475.458-.458.475H71.345l-.441-.407c-.712-.678-.814-1.34-.746-5.139.068-4.953-.017-4.868,5.139-4.868A28.455,28.455,0,0,1,79.131-318.434Z"
                                transform="translate(0 -108.781)"
                              />
                            </g>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="flex-row">
          <input
            type="submit"
            className="onboard-btn-o"
            value="Back"
            onClick={prevPage}
          />
          <input type="submit" className="onboard-btn-f" value="Submit" />
        </div>
      </Form>
    </>
  );
};

export default OverviewPublish;
